const API_BASE_URL = process.env.REACT_APP_USE_LOCAL_EMULATORS === 'true' 
  ? 'http://localhost:5001/europe-fa766/us-central1/api'
  : 'https://api-dailsc74iq-uc.a.run.app';

const SYRVE_API_URL = 'https://api-eu.syrve.live';
const QUICKSHIPPER_AUTH_URL = 'https://auth.quickshipper.app';
const QUICKSHIPPER_DELIVERY_URL = 'https://delivery.quickshipper.app';
const SMS_API_URL = process.env.REACT_APP_USE_LOCAL_EMULATORS === 'true'
  ? 'http://localhost:5001/europe-fa766/us-central1/sendSMS'
  : 'https://sendsms-dailsc74iq-uc.a.run.app';

export const API_BASE = API_BASE_URL;
export const API_PROXY_BASE = `${API_BASE_URL}/proxy`;

export const API_ENDPOINTS = {
  proxy: {
    accessToken: `${API_BASE_URL}/proxy/access_token`,
    organizations: `${API_BASE_URL}/proxy/organizations`,
    menu: `${API_BASE_URL}/proxy/menu`,
    terminalGroups: `${API_BASE_URL}/proxy/terminalgroups`,
    deliveriesCancel: `${API_BASE_URL}/proxy/deliveries/cancel`,
    bogReceipt: (orderBogId) => `${API_BASE_URL}/proxy/bog-receipt/${orderBogId}`,
    bogAuth: `${API_BASE_URL}/proxy/bog-auth`,
    bogCreateOrder: `${API_BASE_URL}/proxy/bog-create-order`,
  },
  syncOrderStatuses: `${API_BASE_URL}/sync-order-statuses`,
  sms: SMS_API_URL,
  quickshipper: {
    auth: `${QUICKSHIPPER_AUTH_URL}/connect/token`,
    delivery: `${QUICKSHIPPER_DELIVERY_URL}/v1/order`,
  },
  admin: {
    verify: `${API_BASE_URL}/admin/verify`,
    init: `${API_BASE_URL}/admin/init`,
  },
  employeeLoyalty: {
    lookup: `${API_BASE_URL}/employee/loyalty/lookup`,
    adjust: `${API_BASE_URL}/employee/loyalty/adjust`,
  },
  disabledCategories: {
    get: (orgId, site = 'fd') => `${API_BASE_URL}/disabled-categories/${orgId}?site=${site}`,
    toggle: `${API_BASE_URL}/disabled-categories/toggle`,
    init: `${API_BASE_URL}/disabled-categories/init`,
  },
  disabledItems: {
    get: (orgId, site = 'fd') => `${API_BASE_URL}/disabled-items/${orgId}?site=${site}`,
    toggle: `${API_BASE_URL}/disabled-items/toggle`,
  },
  fdOnlyModifiers: {
    get: (orgId) => `${API_BASE_URL}/fastdelivery-only-modifiers/${orgId}`,
    toggle: `${API_BASE_URL}/fastdelivery-only-modifiers/toggle`,
  },
  syrve: {
    accessToken: `${SYRVE_API_URL}/api/1/access_token`,
    createOrder: `${SYRVE_API_URL}/api/1/order/create`,
    nomenclature: `${SYRVE_API_URL}/api/1/nomenclature`,
    organizations: `${SYRVE_API_URL}/api/1/organizations`,
    terminalGroups: `${SYRVE_API_URL}/api/1/terminal_groups`,
  },
};

export default API_ENDPOINTS;